import { render, staticRenderFns } from "./userStatistics2.vue?vue&type=template&id=5ead9a4c&scoped=true&"
import script from "./userStatistics2.vue?vue&type=script&lang=ts&"
export * from "./userStatistics2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead9a4c",
  null
  
)

export default component.exports